module.exports = __webpack_public_path__ + "images/bb3d3a2350edb392caac807b185f20f5.svg";